import {logger} from 'tizra'

const log = logger('ssoLogin')

export const ssoLogin = (
  authAgent: 'sso' | 'custom',
  successUrl: string | undefined,
) => {
  if (authAgent === 'sso') {
    const currentUrl =
      window.location.pathname + window.location.search + window.location.hash
    const usp = new URLSearchParams({
      // Caller can pass successUrl to override current page, for example if we
      // are on a dedicated login page, and the user should be returned to their
      // previous page when login completes.
      successUrl: successUrl || currentUrl,
      // Failures should always return to the current page, though.
      failureUrl: currentUrl,
    })
    window.location.assign('/api/sso-redirect?' + usp)
    return
  }

  const {customLoginUrl} = window.tizra
  if (
    log.assert(customLoginUrl, 'authAgent=tizra but customLoginUrl is not set')
  ) {
    window.location.assign(customLoginUrl!)
  }
}
